export function roundToDecimalPlaces(value: number, decimalPlaces: number): number {
  const num = 1 / 10 ** decimalPlaces > Number.EPSILON ? value + Number.EPSILON : value;
  return Math.round(num * 10 ** decimalPlaces) / 10 ** decimalPlaces;
}

export function floorToDecimalPlaces(value: number, decimalPlaces: number): number {
  const num = 1 / 10 ** decimalPlaces > Number.EPSILON ? value + Number.EPSILON : value;
  return Math.floor(num * 10 ** decimalPlaces) / 10 ** decimalPlaces;
}

export function floorToCents(value: number): number {
  return floorToDecimalPlaces(value, 2);
}
